<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnRevenueSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Opbrengsten uit leveringen en diensten')"
                         :calculated-value="data.calculated.statement_revenue_services"
                         v-model="data.edit.statement_revenue_services"/>

      <TaxReturnTableRow :description="$gettext('Loon dat bij de opbrengsten van deze onderneming hoort')"
                         :calculated-value="data.calculated.statement_revenue_salary"
                         v-model="data.edit.statement_revenue_salary"/>

      <TaxReturnTableRow :description="$gettext('Wijziging in voorraden gereed product en onderhanden werk')"
                         :calculated-value="data.calculated.statement_revenue_stock"
                         v-model="data.edit.statement_revenue_stock"/>

      <TaxReturnTableRow :description="$gettext('Geactiveerde productie voor het eigen bedrijf')"
                         :calculated-value="data.calculated.statement_revenue_production"
                         v-model="data.edit.statement_revenue_production"/>

      <TaxReturnTableRow :description="$gettext('Overige opbrengsten')"
                         :calculated-value="data.calculated.statement_revenue_other"
                         v-model="data.edit.statement_revenue_other"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">
table {
  width: 100%;
}
</style>